import {useCallback, useState} from 'react'
import {gql, useMutation} from '@apollo/client'

const SEND_TOPICS_TEACH = gql`
  mutation($otherServices: [OtherEducatorServicesInput!]!, $userId: ID) {
    sendTopicsTeach(otherServices: $otherServices, userId: $userId)
  }
`

export default (onSuccess, onError) => {
  const [mutation, {data, error, loading}] = useMutation(SEND_TOPICS_TEACH)
  //eslint-disable-next-line
  const [validationErrors, setValidationErrors] = useState({})

  const submit = useCallback(
    (obj) => {
      mutation({variables: obj})
        .then((result) => {
          onSuccess(result)
        })
        .catch((e) => {
          if (onError) onError(e)
        })
    },
    [mutation, onSuccess, onError],
  )
  return {
    loading,
    data: data ? data.sendTopicsTeach : null,
    error,
    validationErrors,
    submit,
  }
}
